import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { goldStatement } from "../../../api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import vipOptions from "../../../components/serverList/vipOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
export default {
  components: {
    serverList: serverList,
    vipOptions: vipOptions,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  name: "mainTaskStay",
  data: function data() {
    var h = this.$createElement;
    return {
      options: [{
        value: 0,
        label: "全部"
      }, {
        value: 1,
        label: "产出"
      }, {
        value: 2,
        label: "消耗"
      }],
      optionLabel: "产出",
      value: "",
      searchInfo: {
        statement_type: 1,
        server_id: [],
        vip_levels: []
      },
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableData: [],
      tableDataCount: {},
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "statement_type",
        title: "操作类型",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.statement_type == 1 ? "产出" : "消耗"])];
          }
        }
      }, {
        field: "reason_name",
        title: "操作内容",
        sortable: true
      }, {
        field: "role_vip_level",
        title: "vip等级",
        sortable: true
      }, {
        field: "operation_role_cnt",
        title: "操作人数",
        sortable: true
      }, {
        field: "operation_cnt",
        title: "操作次数",
        sortable: true
      }, {
        field: "cnt",
        title: "元宝总数",
        sortable: true
      }, {
        field: "cnt_avg",
        title: "人均",
        sortable: true
      }, {
        field: "percent",
        title: "元宝占比",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.percent, "%"])];
          }
        }
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.timedata[0];
              _this.searchInfo.edate = _this.timedata[1];
              _context.next = 4;
              return goldStatement(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (_this.searchInfo.statement_type == 1) {
                _this.optionLabel = "产出";
              } else {
                _this.optionLabel = "消耗";
              }
              if (!res.data || res.data.count == 0) {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this.tableData = res.data.list;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "元宝统计",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）根据元宝产出和消耗途径，统计当天的元宝产出和消耗情况</div>" + "<div>（2）可以选择的查询条件包括日期范围（默认昨天）、更改类型（产出、消耗 | 单选）、vip等级（多选，默认全部）、服务器列表（多选，默认全部）</div>" + "<div>（3）显示数据包括（日期，操作内容，更改类型，操作人数，操作次数，元宝总数，人均消费，元宝占比）</div>" + "<div>（4）操作内容对应游戏配置-》事件原因配置</div>",
        duration: 0
      });
    }
  }
};